import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';

const styles = {
  label: {
    // width: '100%',
    // float: 'right',
  },
  input: {
    width: '100%',
  },
  row: {
    marginBottom: '10px',
  },
  col: {
    padding: 0,
    paddingRight: '0px',
    paddingLeft: '0px',
  },
};

class CategoryInfoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.selectedRows[0],
    };
  }

  handleFieldValueChange = (e, fieldName) => {
    e.preventDefault();
    this.setState({
      [fieldName]: e.target.value,
    });
  }

  handleSaveButtonClick = (e) => {
    e.preventDefault();
    this.props.handleConfirmClick(this.state);
  }

  render() {
    return (
      <div>
        <Panel>
          <Row>
            <Col xs={12}>
              <h1 style={{ fontSize: '15px' }}>
                <Translate value="category_display_info" />
              </h1>
            </Col>
          </Row>
          <Row style={styles.row}>
            <Col xs={1}>
              <label style={styles.label}><Translate value="name" />:</label>
            </Col>
            <Col xs={5}>
              <input maxLength="100" style={styles.input} type="text" value={this.state.Name} onChange={(e) => this.handleFieldValueChange(e, 'Name')} />
            </Col>
            <Col xs={1}>
              <label style={styles.label}><Translate value="translation" />:</label>
            </Col>
            <Col xs={5}>
              <input maxLength="100" style={styles.input} type="text" value={this.state.Description} onChange={(e) => this.handleFieldValueChange(e, 'Description')} />
            </Col>
          </Row>
          <Row style={styles.row}>
            <Col xs={1}>
              <label style={styles.label}><Translate value="key" />:</label>
            </Col>
            <Col xs={5}>
              <input disabled={true} style={styles.input} type="text" value={this.state.Key} onChange={(e) => this.handleFieldValueChange(e, 'Key')} />
            </Col>
          </Row>
          <Row>
            <Col xs={1}>
              <label style={styles.label}><Translate value="category_description" />:</label>
            </Col>
            <Col xs={11}>
              {/* <input style={styles.input} type="text" value={this.state.CategoryDescription} onChange={(e) => this.handleFieldValueChange(e, 'CategoryDescription')} /> */}
              <textarea rows={5} maxLength="1500" style={styles.input} value={this.state.CategoryDescription} onChange={(e) => this.handleFieldValueChange(e, 'CategoryDescription')} />
            </Col>
          </Row>
        </Panel>

        <Panel>
          <Row>
            <Col xs={12}>
              <h1 style={{ fontSize: '15px' }}>
                <Translate value="category_meta_info" />
              </h1>
            </Col>
          </Row>
          <Row style={styles.row}>
            <Col xs={1}>
              <label style={styles.label}><Translate value="meta_title" />:</label>
            </Col>
            <Col xs={11}>
              <input maxLength="100" style={styles.input} type="text" value={this.state.MetaTitle} onChange={(e) => this.handleFieldValueChange(e, 'MetaTitle')} />
            </Col>
          </Row>
          <Row style={styles.row}>
            <Col xs={1}>
              <label style={styles.label}><Translate value="meta_keywords" />:</label>
            </Col>
            <Col xs={11}>
              <input maxLength="500" style={styles.input} type="text" value={this.state.MetaKeywords} onChange={(e) => this.handleFieldValueChange(e, 'MetaKeywords')} />
            </Col>
          </Row>
          <Row>
            <Col xs={1}>
              <label style={styles.label}><Translate value="meta_description" />:</label>
            </Col>
            <Col xs={11}>
              <textarea rows={3} maxLength="500" style={styles.input} type="text" value={this.state.MetaDescription} onChange={(e) => this.handleFieldValueChange(e, 'MetaDescription')} />
            </Col>
          </Row>
        </Panel>

        <Button
          bsStyle="success"
          className="buttonStyle"
          onClick={(event) => { this.handleSaveButtonClick(event); }}
          style={{ float: 'right' }}
        >
          <em className="fa fa-save marginRightStyle" /><Translate value="confirm" />
        </Button>
      </div>
    );
  }
}

export default CategoryInfoModal;




// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/categoryInfoModal.jsx